/**
 * Janela (em minutos) usada pelo front para decidir a bolinha "online" a
 * partir de `pessoa.ultimaInteracao`. Deve ser sempre ≥
 * `PESSOA_INTERACAO_DEBOUNCE_MINUTOS` (back, `domain/constants/pessoa-interacao.constants.ts`)
 * — se for menor, a bolinha pisca perto do limite do debounce de escrita.
 */
export const PESSOA_ONLINE_THRESHOLD_MINUTOS = 8;
